var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-container"},[_c('b-modal',{ref:"logoutWarningModal",staticClass:"bootstrap-modal nopadding",attrs:{"hide-footer":"","hide-header":"","centered":"","static":"","lazy":""}},[_c('div',{staticClass:"modal-contents"},[_c('h2',[_vm._v(_vm._s(_vm.$t('interface.oops')))]),_c('p',[_vm._v(_vm._s(_vm.$t('interface.logout-warning')))]),_c('div',{staticClass:"buttons"},[_c('standard-button',{attrs:{"options":{
            title: _vm.$t('interface.go-back'),
            buttonStyle: 'green-border',
            rightArrow: false,
            leftArrow: false,
            fullWidth: true,
            noMinWidth: true
          },"click-function":_vm.cancel}}),_c('standard-button',{attrs:{"options":{
            title: _vm.$t('interface.logout-wallet'),
            buttonStyle: 'red',
            rightArrow: false,
            leftArrow: false,
            fullWidth: true,
            noMinWidth: true
          },"click-function":_vm.logout}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }